import BrandBadge from '../BrandBadge';
import ClusterIcon from '../ClusterIcon';
import ClusterTooltip from '../ClusterTooltip';
import { PlaceholderText } from '../Placeholders';
import TikTokEmptyClusterIcon from '../TikTokEmptyClusterIcon';
import styled from 'styled-components';

const TikTokNameBodyColWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: ${({ $height }) => $height || '50px'};
    width: 100%;
    max-width: 100%;
    letter-spacing: 0;
    min-width: 0;
`;

const HashtagList = styled.div`
    font-style: normal;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 18px;
    color: ${({ theme }) => theme.black};
    text-transform: lowercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: keep-all;
    text-transform: none;
`;

const NameText = styled.span`
    text-transform: capitalize;
    font-weight: 600;
`;
const HashtagText = styled.span`
    text-transform: none;
    word-break: keep-all;
    font-weight: 400;
`;

function Name({ isHashtagData, fetching, children }) {
    if (children && !isHashtagData) {
        return <NameText>{children}</NameText>;
    } else if (children) {
        return <HashtagText>{children}</HashtagText>;
    } else if (fetching) {
        return '...';
    }
    return <>&mdash;</>;
}

const ClusterWrapper = styled.span`
    display: flex;
    align-items: center;
    margin-right: 8px;
`;

const NameIconRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${({ theme }) => theme.gray_1};
    font-size: 16px;
    font-weight: 600;
`;

const TikTokNameBodyColInner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    flex-grow: 1;
`;

const TableClusterIcon = styled(ClusterIcon)`
    font-size: 1.125rem;
`;

function TikTokNameBodyCol({
    row,
    isHashtagData,
    type,
    hideBrandBadge = true,
}) {
    const $height = isHashtagData && type !== 'brands' ? '50px' : '75px';
    return (
        <TikTokNameBodyColWrapper $height={$height}>
            <TikTokNameBodyColInner>
                <NameIconRow>
                    <Name fetching={row.fetching} isHashtagData={isHashtagData}>
                        {row.name}
                    </Name>
                    <ClusterWrapper>
                        {row.cluster ? (
                            <ClusterTooltip
                                cluster={row.cluster}
                                dataSource="tiktok"
                            >
                                <TableClusterIcon cluster={row.cluster} />
                            </ClusterTooltip>
                        ) : row.fetchingData ? (
                            <PlaceholderText width="1.125rem" />
                        ) : (
                            <TikTokEmptyClusterIcon />
                        )}
                    </ClusterWrapper>
                </NameIconRow>
                {!isHashtagData ? (
                    <HashtagList>{row.hashtag_list}</HashtagList>
                ) : type === 'brands' ? (
                    <div>
                        {hideBrandBadge ? (
                            <span>{row.brand_name}</span>
                        ) : (
                            <BrandBadge name={row.brand_name} />
                        )}
                    </div>
                ) : null}
            </TikTokNameBodyColInner>
        </TikTokNameBodyColWrapper>
    );
}

export default TikTokNameBodyCol;
